export default "__VITE_ASSET__Qp7pVaKw__"